<template>
  <div class="hitTeacher" v-if="data && data.length > 0" v-swiper:mySwiper="swiperOption">
    <div class="swiper-wrapper">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="swiper-slide teachers swiper-no-swiping"
      >
        <div class="teachers__item">
          <div class="teachers__item__attr">
            <span class="teachers__item__name">{{ computedName(item.name) }}</span>
            <!-- <span class="teachers__item__hr"></span>
            <span class="teachers__item__subject">{{ item.subjectNames }}</span> -->
          </div>
          <div class="teachers__item__info" v-if="item.courseNum">
            当前在售{{ item.courseNum }}期课程
          </div>
          <a
            class="teachers__item__enter"
            target="_blank"
            :href="`//online.xueersi.com/t/${item.id}`"
            @click="
              handClick({ clickurl: `online.xueersi.com/t/${data.id}` }, $event)
            "
            >个人主页</a
          >
        </div>
        <div
          class="teachers__img"
          :style="{ backgroundImage: `url(${item.avatar})` }"
        ></div>
      </div>
    </div>
    <template v-if="data.length > 2">
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['data'],
  data() {
    return {
      swiperOption: {
        noSwiping: true,
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        slidesPerView: 2,
        spaceBetween: 24,
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        navigation: {
          nextEl: '.swiper-button-next', // 前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', // 后退按钮的css选择器或HTML元素。
          disabledClass: 'my-button-disabled', // 前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden' // 按钮隐藏时的Class
        }
      }
    }
  },
  computed: {
    ...mapState({
      chooseSift: state => state.SearchPage.chooseSift,
      siftName: state => state.SearchPage.siftName,
      dataExpTag: state => state.SearchPage.dataExpTag
    }),
    keyword() {
      const { keyword = '' } = this.$route.query
      return keyword
    }
  },
  methods: {
    computedName(name) {
      // eslint-disable-next-line no-control-regex
      var r = /[^\x00-\xff]/g
      if (name.replace(r, 'mm').length <= 8) {
        return name
      }
      var m = Math.floor(8 / 2)
      for (var i = m; i < name.length; i++) {
        if (
          name.substr(0, i).replace(r, 'mm').length >= 8 &&
          name.substr(0, i).replace(r, 'mm').length < 9
        ) {
          return name.substr(0, i) + '...'
        }
        if (name.substr(0, i).replace(r, 'mm').length === 9) {
          return name.substr(0, i - 1) + '...'
        }
      }
      return name
    },
    handClick(data, event) {
      this.xesLog(data, event)
    },
    xesLog({ clickurl = '' }, event) {
      const XESLog = new this.$XESLog({
        key: 'xeslog-searchTeacherClick-www',
        clickid: '1.4.27',
        clickurl: clickurl,
        teacherid: this.data.id,
        teachername: this.data.name,
        subjectid: this.data.subjectNames,
        salenum: this.data.courseNum,
        sorttype: this.$route.query.sort ? this.$route.query.sort : 1,
        setgradeid: this.$store.state.cookies.userGrade,
        curgradeid: this.$store.state.cookies.currentGrade,
        query: this.keyword,
        exp_tag: this.dataExpTag
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(hitTeacher) {
  overflow: hidden;
  position: relative;
  margin-top: 20px;
  height: 240px;
}
@include b(teachers) {
  position: relative;
  width: 588px;
  height: 240px;
  background-image: url(../images/teacher2-bg.png);
  background-repeat: no-repeat;
  background-size: 588px 240px;
  text-align: right;
  @include e(img) {
    position: absolute;
    width: 220px;
    height: 210px;
    overflow: hidden;
    top: 30px;
    right: 64px;
    vertical-align: middle;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0;
  }
  @include e(item) {
    position: absolute;
    right: 328px;
    top: 76px;
    vertical-align: middle;
    box-sizing: border-box;
    text-align: left;
    @include e(attr) {
      & > span {
        color: #333333;
        font-size: 28px;
        font-weight: bold;
        display: inline-block;
        vertical-align: middle;
      }
    }
    @include e(name) {
      white-space: nowrap;
      vertical-align: middle;
    }
    @include e(hr) {
      border-left: 1px solid #333333;
      height: 26px;
      margin: 0 16px;
      opacity: 0.2;
    }
    @include e(info) {
      color: #666666;
      font-size: 16px;
      margin-top: 12px;
      line-height: 16px;
    }
    @include e(subject) {
    }
    @include e(enter) {
      box-sizing: border-box;
      margin-top: 24px;
      display: block;
      width: 146px;
      height: 32px;
      text-align: center;
      border: 1px solid #c1c7db;
      font-size: 14px;
      color: #666666;
      line-height: 30px;
      border-radius: 2px;
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  width: 26px;
  height: 48px;
  background: #000000;
  opacity: 0.1;
  background-size: 26px 48px;
  &:hover {
    opacity: 0.3;
  }
}
.swiper-button-prev {
  background-image: url('../images/arrows-left.png');
  background-repeat: no-repeat;
  left: 12px;
}
.swiper-button-next {
  background-image: url('../images/arrows-right.png');
  background-repeat: no-repeat;
  right: 12px;
}
.my-button-disabled {
  // display: none;
  &:hover {
    opacity: 0.1;
  }
  cursor: not-allowed;
}
.my-button-hidden {
  // display: none;
  &:hover {
    opacity: 0.1;
  }
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// ./src/views/SearchPage/components/TeacherSwiper.vue